import { PaymentFoerdersummenDisplayModel } from "@/api/model-index";
import { AnfrageService } from "@/api/service-index";
import { PaymentService } from "@/core/services/payment.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GetAllAnfrageFundingAmountsResolver implements Resolve<PaymentFoerdersummenDisplayModel> {
  constructor(protected anfrageService: AnfrageService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService, protected paymentService: PaymentService){}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PaymentFoerdersummenDisplayModel> {
    let id: string = <string>route.params['id'];

    await this.unfinishedHttpMethodsService.waitByUrl(state.url);

    return this.anfrageService.apiAnfrageAnfrageIdFundsPaymentsGet({ anfrageId: id }).pipe(map(response => {
      this.paymentService.formGroup.patchValue(response);
      
      if (response.payments)
        this.paymentService.payments = response.payments;
      
      return response;
    })).toPromise();
  }
}